import { Common } from '../../middleware/index'
import appointDialog from "@/components/dialog/appoint/index"
interface Booking {
    provinceCode:string;
    cityCode:string;
    carType:string;
    userName:string;
    userPhone:string;
    storeCode:string;
}

export class Appoint extends Common {
    public get request(){
        return (this as any).$axios
    }
    /**
     * 获取省份信息
     */
    public async getProvinces() {
        const res = (await this.request.get('/faw/keepInfo/provinces')) as any;
        return res.data || []
    }
    /**
     * 获取城市信息
     */
    public async getCityies(provinceCode:string) {
        const res = (await this.request.get('/faw/keepInfo/cities?province='+provinceCode)) as any;
        return res.data || []
    }
    public async getStoreList(provinceCode:string,cityCode:string) {
        const res = (await this.request.get('/faw/keepInfo/dealers?province='+provinceCode+'&city='+cityCode)) as any;
        return res.data || []
    }

    public showAppointDialog(data:any){
        return new Promise((resolve)=>{
            appointDialog();
        })
    }

    public async checkIsExist(params:Booking,callback:Function) {
        const res = (await this.request.post('/faw/keepInfo/exists',params)) as any;
        if(res.code!=200){
            (this as any).$dialog.alert({
                message: res.message
            })
        }else{
            callback&&callback(this.showAppointDialog.bind(this,res.data),res.data);
        }
    }

    public async booking(params:Booking,callback:Function){
        console.log(params)
        const res = (await this.request.post('/faw/keepInfo/keepInfo',params)) as any;
        if(res.code!=200){
            (this as any).$dialog.alert({
                message: res.message
            })
        }else{
            callback&&callback(res.data);
        }
    }
}